import { render, staticRenderFns } from "./PanelViewShow.vue?vue&type=template&id=71be4ed1&"
import script from "./PanelViewShow.vue?vue&type=script&lang=js&"
export * from "./PanelViewShow.vue?vue&type=script&lang=js&"
import style0 from "./PanelViewShow.vue?vue&type=style&index=0&id=71be4ed1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports